import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  { path: 'events', redirectTo: 'events/list', pathMatch: 'full' },
  {
    path: 'events',
    children: [
      {
        path: 'list',
        loadComponent: () => import('./list/events.component').then((m) => m.EventsComponent),
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./details/events-details.component').then((m) => m.EventsDetailsComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class eventsRoutingModule {
  static routes = admin;
}
